import FileUploadPage from "./fileupload1";
import "./App.css";

function App() {
  return (
    <div>
      <FileUploadPage />
    </div>
  );
}

export default App;
